import { render, staticRenderFns } from "./CampaignView.vue?vue&type=template&id=4e9f8c03&scoped=true&"
import script from "./CampaignView.vue?vue&type=script&lang=js&"
export * from "./CampaignView.vue?vue&type=script&lang=js&"
import style0 from "./CampaignView.vue?vue&type=style&index=0&id=4e9f8c03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9f8c03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/matt/dev/georgia/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9f8c03')) {
      api.createRecord('4e9f8c03', component.options)
    } else {
      api.reload('4e9f8c03', component.options)
    }
    module.hot.accept("./CampaignView.vue?vue&type=template&id=4e9f8c03&scoped=true&", function () {
      api.rerender('4e9f8c03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CampaignView.vue"
export default component.exports